import { render, staticRenderFns } from "./Permanent.vue?vue&type=template&id=55a0e9d8&"
import script from "./Permanent.vue?vue&type=script&lang=js&"
export * from "./Permanent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports